<div style="padding-bottom: 16px">
  <mat-form-field style="width: 100%">
    <ngx-mat-file-input [multiple]="false" [accept]="'image/*'" [(ngModel)]="file" (ngModelChange)="loadFile($event)"
                        required></ngx-mat-file-input>
  </mat-form-field>
</div>
